import React from 'react';

/**
 * Slider — a single-value range slider (native input, design-system styled).
 *
 * Props:
 *   value, onChange(next)
 *   min, max, step
 *   showValue: boolean | (v) => ReactNode
 *   disabled, ariaLabel
 */
const Slider = ({
  value = 0,
  onChange,
  min = 0,
  max = 100,
  step = 1,
  showValue = false,
  disabled = false,
  ariaLabel,
  className = '',
}) => {
  const pct = max === min ? 0 : ((value - min) / (max - min)) * 100;
  const label = typeof showValue === 'function' ? showValue(value) : value;
  return (
    <div className={`ps-slider${disabled ? ' is-disabled' : ''} ${className}`.trim()}>
      <input
        type="range"
        className="ps-slider__input"
        style={{ '--ps-slider-fill': `${pct}%` }}
        min={min}
        max={max}
        step={step}
        value={value}
        disabled={disabled}
        aria-label={ariaLabel}
        onChange={(e) => onChange?.(Number(e.target.value))}
      />
      {showValue && <span className="ps-slider__value">{label}</span>}
    </div>
  );
};

export default Slider;
